


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Shards } from '@service/solr/collections';

@Component
export default class ShardsComponent extends Vue {
  @Prop({
    required: true,
  })
  private shards!: { [name: string]: Shards };

  private shardsFormatter(shards: { [name: string]: Shards }) {
    return Object.keys(shards).map((name) => {
      const shard = shards[name];
      shard.name = name;
      return shard;
    });
  }
}
